interface FeatureFlagOverrideOptions {
  isDevelopment: boolean;
  overrides?: string;
  flag: string;
}

export const isFeatureFlagOverridden = ({
  isDevelopment,
  overrides,
  flag,
}: FeatureFlagOverrideOptions) => {
  if (!isDevelopment || !overrides) {
    return false;
  }

  const configuredOverrides = overrides
    .split(',')
    .map((override) => override.trim())
    .filter(Boolean);

  return (
    configuredOverrides.includes('*') || configuredOverrides.includes(flag)
  );
};
